module.exports = __webpack_public_path__ + "img/logo.fc76f151.png";